import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCard = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.66 3.34H1.34A1.25 1.25 0 0 0 0 4.5v14.83a1.29 1.29 0 0 0 1.21 1.34h21.45A1.28 1.28 0 0 0 24 19.46V4.68a1.19 1.19 0 0 0-1-1.34ZM2.67 6H12v9.33c-.44-.26-1.68-.51-2.37-.8a1.49 1.49 0 0 1-1.34-1.61 4.24 4.24 0 0 0 1.25-3A2.29 2.29 0 0 0 5 9.21a2.2 2.2 0 0 0 0 .73 4.3 4.3 0 0 0 1.2 2.9A1.42 1.42 0 0 1 5 14.47h-.06c-.67.27-1.87.63-2.29.86V6Zm18 12H3.33a.67.67 0 0 1 0-1.33h17.33a.67.67 0 0 1 0 1.33Zm0-5.33H14a.67.67 0 0 1 0-1.33h6.67a.67.67 0 0 1 0 1.33m0-2.66H14a.67.67 0 0 1 0-1.34h6.67a.67.67 0 0 1 0 1.34m0-2.67H14A.67.67 0 0 1 14 6h6.67a.67.67 0 0 1 0 1.33Z"
    }));
export default SvgCard;
